import React from 'react';
import { isCardExpired } from "../../payment/helper";

export function isZipValid(value) {
    if(value.length === 5){
      return true
    } else {
      return false
    }
}

export function assignPriceToCards(price, cards, fromFS) {
  const primaryCard = cards.find(card => ((card.isFederalBenefitCard || card.isFederal) || (card.isCommuterBenefitCard || card.isCommuter) || (parseFloat(card.maxAuthorizedAmount ?? card.maxAmount) > 0)) && (card.isPrimary || card.isDefault));
  const backupCard = cards.find(card => !((card.isFederalBenefitCard || card.isFederal) || (card.isCommuterBenefitCard || card.isCommuter)) && card.isBackup);
  const notFederalPrimaryCard = cards.find(card => !((card.isFederalBenefitCard || card.isFederal) || (card.isCommuterBenefitCard || card.isCommuter)) && (card.isPrimary || card.isDefault));
  if(primaryCard || backupCard){
    const maxAmountFromCard = primaryCard.maxAuthorizedAmount || primaryCard.maxAmount;
    const maxAuthAmount = parseFloat(maxAmountFromCard);
    if(price <= maxAuthAmount){
      primaryCard.chargeAmount = price;
      if(backupCard){
        backupCard.chargeAmount = 0;
        if(fromFS){
          return [primaryCard];
        }else{
          return [primaryCard,backupCard];
        }
      }
      return [primaryCard];
    }
    else if(price > maxAuthAmount) {
      primaryCard.chargeAmount = maxAuthAmount;
      if(backupCard){
        backupCard.chargeAmount = price - maxAuthAmount;
        return [primaryCard,backupCard]
      }
      return [primaryCard];
    }
  }
  else if(notFederalPrimaryCard){
    notFederalPrimaryCard.chargeAmount = price;
    return [notFederalPrimaryCard]
  }
}

function getSliceNumber(length){
  if(length % 4 === 0){
    return -4;
  } else {
    return (length % 4) * -1
  }
}

export function getMaskedCardNumber(cardNumber) {
  let value = cardNumber.replace(/\D/g, '');
  if (value.length > 4) {
      const sliceNum = getSliceNumber(cardNumber.length);
      value = value.slice(0, sliceNum).replace(/\d/g, '*') + value.slice(sliceNum);
  }
  return value;
}
